module.exports = __webpack_public_path__ + "static/media/KOM_00.a3d898d7.png";